// resources/js/bootstrap.js
import axios from 'axios';

// 1) Base headers
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

axios.interceptors.request.use((config) => {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
  if (token) {
    config.headers['X-CSRF-TOKEN'] = token; // always the latest from DOM
  }
  return config;
});
// 2) Helper to sync CSRF from the current <meta> tag
export function applyCsrfFromMeta() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  const token = meta?.getAttribute('content') || '';
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token;

  // (Optional) keep any existing <input name="_token"> in sync too
  document.querySelectorAll('input[name="_token"]').forEach(i => (i.value = token));
}

// 3) Run once at boot
applyCsrfFromMeta();

// 4) Interceptor: handle 419 (stale token) -> refresh token -> retry once
let refreshing = null;
axios.interceptors.response.use(
  r => r,
  async error => {
    const res = error?.response;
    const cfg = error?.config || {};
    if (!res) return Promise.reject(error);

    // Handle Inertia hard-redirects (409 + X-Inertia-Location)
    if (res.status === 409) {
      const loc = res.headers?.['x-inertia-location'];
      if (loc) {
        window.location.assign(loc);
        return; // stop chain
      }
      // Fallback: reload
      window.location.reload();
      return;
    }

    // Handle CSRF mismatch once
    if (res.status === 419 && !cfg.__retried) {
      try {
        // de-dupe concurrent refreshes
        if (!refreshing) {
          refreshing = axios.get(route('csrf.refresh'), { withCredentials: true })
            .then(({ data }) => {
              const token = data.token;
              // update axios default + meta + hidden inputs
              axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
              const meta = document.querySelector('meta[name="csrf-token"]');
              if (meta) meta.setAttribute('content', token);
              document.querySelectorAll('input[name="_token"]').forEach(i => (i.value = token));
              return token;
            })
            .finally(() => { setTimeout(() => (refreshing = null), 0); });
        }

        await refreshing;

        // retry original once
        cfg.__retried = true;
        return axios(cfg);
      } catch (e) {
        // If refresh fails, go to login
        window.location.assign(route('login') ?? '/login');
        return Promise.reject(e);
      }
    }

    return Promise.reject(error);
  }
);

window.axios = axios;

